const WebSocket = require('websocket').w3cwebsocket;
const Socket = require('./phoenix').Socket;

import Vue from 'vue';

const socketService = {
  _publicSocket: null,
  _privateSocket: null,
  publicEndpoint: process.env.WS_URL,
  privateEndpoint: process.env.ADMIN_WS_URL,
  get publicSocket() {
    if (this._publicSocket === null) {
      this._publicSocket = new Socket(this.publicEndpoint, {transport: WebSocket});
    }
    return this._publicSocket;
  },
  get privateSocket() {
    if (this._privateSocket === null) {
      return (token = null) => {
        if (typeof token === "string") {
          token = {token}
        }
        this._privateSocket = new Socket(this.privateEndpoint, {params: token, transport: WebSocket});
        return this._privateSocket;
      }
    }
    return () => { return this._privateSocket; }
  }
};

Vue.use(socketService)

export default (context, inject) => {
  inject('socketService', socketService);
}
